import { Button } from "@/components/ui/button"
import { Menu as NativeMenu, Portal } from "@chakra-ui/react"
import Icon, { Icons } from "./Icons"

const Menu = ({ title, items }: { title: string, items: Array<{ title: string, onClick: () => void }> }) => {
    return (
        <NativeMenu.Root>
            <NativeMenu.Trigger asChild>
                <Button variant="solid" size="sm">
                    {title}
                    <Icon icon={Icons.caretDown} />
                </Button>
            </NativeMenu.Trigger>
            <Portal>
                <NativeMenu.Positioner>
                    <NativeMenu.Content>
                        {items.map((item) => (
                            <NativeMenu.Item value={item.title} key={item.title} onClick={item.onClick}>
                                {item.title}
                            </NativeMenu.Item>
                        ))}

                    </NativeMenu.Content>
                </NativeMenu.Positioner>
            </Portal>
        </NativeMenu.Root>
    )
}

export default Menu;